// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseInput-module__container___1pHwC","input":"BaseInput-module__input___1hZh_","rounded":"BaseInput-module__rounded___FI1_7"};